<template>
	<svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.865 5.365H5.115V9.115H3.885V5.365H0.135V4.135H3.885V0.385H5.115V4.135H8.865V5.365Z" :class="iconColor" />
	</svg>
</template>

<script setup>
defineProps({
	iconColor: {
		type: String,
		default: "fill-nobel",
	},
});
</script>
